export default class HeaderMenu {
  private burger: HTMLElement | null;
  private overlay: HTMLElement | null;
  private menu: HTMLElement | null;
  private closeBtn: HTMLElement | null;
  private body: HTMLElement;
  private _focusHandler?: (e: KeyboardEvent) => void;

  constructor() {
    this.burger = document.querySelector('.js-burger');
    this.overlay = document.querySelector('.menu-out-overlay');
    this.menu = document.querySelector('.js-menu');
    this.closeBtn = document.querySelector('.js-menu-close');
    this.body = document.body;

    this.init();
  }

  init() {
    this.burger?.addEventListener('click', () => this.openMenu());
    this.closeBtn?.addEventListener('click', () => this.closeMenu());
    this.initAccordion();
    this.initEscape();
    this.initClickOutside();
    this.initCountDown();
    this.initMoreButton();
    this.initScroll();
  }

  initClickOutside() {
    document.addEventListener('click', (e) => {
      if (!this.menu?.classList.contains('is-open')) return;
      if (this.menu.contains(e.target as Node)) return;
      if (this.burger?.contains(e.target as Node)) return;

      this.closeMenu();
    });
  }
  
  initScroll() {
	const header = document.querySelector(".header");

	function updateHeaderBackground() {
		if (!header) return;
			header.classList.toggle("is-scrolled", window.scrollY > 50);
		}

		updateHeaderBackground();

		window.addEventListener("scroll", updateHeaderBackground, {
			passive: true,
		});
  }
  
  initMoreButton() {
  	document.querySelectorAll<HTMLElement>('.editorial-block__toggle')
	.forEach(button => {

		button.addEventListener('click', () => {

			const block = button.closest('.editorial-block');

			if (!block) return;

			const isOpen = block.classList.toggle('is-open');

			button.setAttribute('aria-expanded', String(isOpen));
		});
	});
  }

  openMenu() {
	  this.menu.classList.add('is-open');
	  this.overlay.classList.add('open');
	  this.menu.setAttribute('aria-hidden', 'false');
	  this.burger.setAttribute('aria-expanded', 'true');
	  
	  document.body.classList.add('no-scroll');

	  const firstLink = this.menu.querySelector('a, button') as HTMLElement;
	  firstLink?.focus();
	  
	  this.trapFocus();
  }

  closeMenu() {
	  this.menu.classList.remove('is-open');
	  this.overlay.classList.remove('open');
	  this.menu.setAttribute('aria-hidden', 'true');
	  this.burger.setAttribute('aria-expanded', 'false');

	  document.body.classList.remove('no-scroll');

	  this.removeFocusTrap();

	  this.burger.focus();
  }

  toggleMenu() {
	  const isOpen = this.menu.classList.toggle('is-open');

	  this.burger.setAttribute('aria-expanded', String(isOpen));
	  this.menu.setAttribute('aria-hidden', String(!isOpen));

	  document.body.classList.toggle('no-scroll');
  }

  initAccordion() {
	  const items = document.querySelectorAll<HTMLElement>('.menu-item-has-children');

	  items.forEach((item) => {
		if (item.dataset.accordionInit === 'true') return;
		item.dataset.accordionInit = 'true';

		const trigger = item.querySelector(':scope > a') as HTMLElement;
		const subMenu = item.querySelector(':scope > .sub-menu') as HTMLElement;

		if (!trigger || !subMenu) return;

		trigger.setAttribute('aria-expanded', 'false');
		subMenu.setAttribute('aria-hidden', 'true');
		subMenu.style.height = '0px';

		trigger.addEventListener('click', (e) => {
		  e.preventDefault();

		  const isOpen = item.classList.contains('is-active');

		  items.forEach((el) => {
		    if (el === item) return;

		    const t = el.querySelector(':scope > a') as HTMLElement;
		    const sm = el.querySelector(':scope > .sub-menu') as HTMLElement;

		    if (!sm) return;

		    if (el.classList.contains('is-active')) {
		      const h = sm.scrollHeight;

		      sm.animate(
		        [
		          { height: h + 'px' },
		          { height: h + 20 + 'px' },
		          { height: '0px' }
		        ],
		        { duration: 400, easing: 'ease-out' }
		      );

		      setTimeout(() => {
		        sm.style.height = '0px';
		      }, 400);
		    }

		    el.classList.remove('is-active');
		    t?.setAttribute('aria-expanded', 'false');
		    sm.setAttribute('aria-hidden', 'true');
		  });

		  if (!isOpen) {
		    item.classList.add('is-active');
		    trigger.setAttribute('aria-expanded', 'true');
		    subMenu.setAttribute('aria-hidden', 'false');
		    subMenu.style.height = subMenu.scrollHeight + 'px';
		  } else {
		    const h = subMenu.scrollHeight;

		    subMenu.animate(
		      [
		        { height: h + 'px' },
		        { height: h + 20 + 'px' },
		        { height: '0px' }
		      ],
		      { duration: 400, easing: 'ease-out' }
		    );

		    setTimeout(() => {
		      subMenu.style.height = '0px';
		    }, 400);

		    item.classList.remove('is-active');
		    trigger.setAttribute('aria-expanded', 'false');
		    subMenu.setAttribute('aria-hidden', 'true');
		  }
		});
	  });
  }
	
  initEscape() {
	  document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') {
		  if (this.menu.classList.contains('is-open')) {
		    this.closeMenu();
		  }
		}
	  });
  }
  
  trapFocus() {
	  const focusable = this.menu.querySelectorAll(
		'a, button, input, [tabindex]:not([tabindex="-1"])'
	  );

	  if (!focusable.length) return;

	  const first = focusable[0] as HTMLElement;
	  const last = focusable[focusable.length - 1] as HTMLElement;

	  const handleKeydown = (e: KeyboardEvent) => {
		if (e.key !== 'Tab') return;

		if (e.shiftKey) {
		  if (document.activeElement === first) {
		    e.preventDefault();
		    last.focus();
		  }
		} else {
		  if (document.activeElement === last) {
		    e.preventDefault();
		    first.focus();
		  }
		}
	  };

	  this._focusHandler = handleKeydown;

	  document.addEventListener('keydown', handleKeydown);
  }
  
  removeFocusTrap() {
	  if (this._focusHandler) {
		document.removeEventListener('keydown', this._focusHandler);
	  }
  }
  
  initCountDown() {
  	document.querySelectorAll<HTMLElement>('.hero-landoy__countdown').forEach((el) => {
		const dateStr = el.dataset.date;

		if (!dateStr) return;

		const targetDate = new Date(dateStr);

		if (isNaN(targetDate.getTime())) {
			console.error('Date invalide:', dateStr);
			return;
		}

		const update = () => {
			const now = new Date();
			const diff = targetDate.getTime() - now.getTime();

			if (diff <= 0) return;

			const totalHours = Math.floor(diff / (1000 * 60 * 60));

			const months = Math.floor(totalHours / (24 * 30));
			const days = Math.floor((totalHours % (24 * 30)) / 24);
			const hours = totalHours % 24;

			const values = el.querySelectorAll<HTMLElement>('.value');

			if (values.length >= 3) {
				values[0].textContent = String(months);
				values[1].textContent = String(days);
				values[2].textContent = String(hours);
			}
		};

		update();
		setInterval(update, 60000);
	});
  
  }
  
}
